import React, { type CSSProperties, useEffect, type ReactNode, type RefObject } from 'react';

interface ClickOutsideHandlerProps {
  children: ReactNode;
  onOutsideClick: () => void;
  className: string;
  wrapperRef: RefObject<HTMLDivElement>;
  style?: CSSProperties;
}

const ClickOutsideHandler: React.FC<ClickOutsideHandlerProps> = ({ children, onOutsideClick, className, wrapperRef, style }) => {
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (wrapperRef.current != null && !wrapperRef.current.contains(event.target as Node)) {
        onOutsideClick();
      }
    };

    // Bind the event listener
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onOutsideClick, wrapperRef]);

  return (
    <div ref={wrapperRef} className={className} style={style}>
      {children}
    </div>
  );
};

export default ClickOutsideHandler;
